// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { FEATURE_CANDIDATES } from '@/constants/features';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard';
import { multiGuard } from '@/core/guards/guardComposer.js';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.users.list],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['view'] },
            { resource: 'portal.user.working-profiles', scopes: ['view'] },
            { resource: 'portal.candidate', scopes: ['view'] }
        ]),
        controller: () => import('@/modules/users/controllers/users')
    },
    {
        path: [config.routes.users.usersWorkingProfiles],
        guard: getPermissionsGuard([{ resource: 'portal.user.working-profiles', scopes: ['view'] }]),
        controller: () => import('@/modules/users/controllers/usersWorkingProfiles')
    },
    {
        path: [config.routes.users.candidateSearch],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CANDIDATES),
            getPermissionsGuard([{ resource: 'portal.candidate', scopes: ['view'] }])
        ]),
        controller: () => import('@/modules/users/controllers/candidateSearch')
    },
    {
        path: [config.routes.users.selectGroupsForExisting],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.selectGroupsByHierarchy],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.selectGroups],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.userIntegration],
        guard: getPermissionsGuard([{ resource: 'portal.user-integration', scopes: ['create'] }]),
        controller: () => import('@/modules/users/controllers/userIntegration')
    },
    {
        path: [config.routes.users.user],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] },
            { resource: 'portal.user.working-profiles', scopes: ['all'] }
        ]),
        controller: () => import('@/modules/users/controllers/user')
    },
    {
        path: [config.routes.users.editWorkingProfiles],
        guard: getPermissionsGuard([
            { resource: 'portal.user.working-profiles', scopes: ['view'] },
            { resource: 'portal.user.working-profiles', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/editWorkingProfiles')
    },
    {
        path: [config.routes.users.mergeUsers],
        guard: getPermissionsGuard([{ resource: 'portal.user', scopes: ['merge'] }]),
        controller: () => import('@/modules/users/controllers/mergeUsers')
    }
];
